const error = (state = {}, action) => {
	switch (action.type) {
		case 'SET_ERROR':
			return { ...state, ...action.data };
		case 'RESET_ERROR':
			return {};
		default:
			return state;
	}
};
export default error;
